/**
 * 請求書PDFの表示。
 *
 * 請求書は専用ページ（BillingPdfView）で実データから描画し、
 * ブラウザの印刷（PDFとして保存）でPDF化する。固定のサンプルPDFは使用しない。
 */
import { InvoiceSummary } from "./types";

/**
 * PDF表示: 請求書のみを表示する専用ページ（ヘッダー・サイドバー無し）を新規タブで開く。
 */
export const openInvoicePdf = (inv: InvoiceSummary): void => {
  window.open(
    `/setting/billing/${inv.id}/pdf`,
    "_blank",
    "noopener,noreferrer"
  );
};
